import React, { useState, useEffect } from 'react';
import Sidebar from '../components/layout/Sidebar';
import Topbar from '../components/layout/Topbar';
import { authAPI } from '../services/api';
import styles from './Dashboard.module.css';

function Dashboard() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await authAPI.getMe();
        setUser(userData);
      } catch (error) {
        console.error('Failed to fetch user:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <div className={styles.dashboardContainer}>
      <Sidebar />
      <div className={styles.mainContent}>
        <Topbar user={user} />
        <div className={styles.contentArea}>
          <div className={styles.welcomeCard}>
            {loading ? (
              <p>Chargement...</p>
            ) : (
              <>
                <h1>Bienvenue sur Xanlite</h1>
                {user && <p className={styles.userEmail}>{user.email}</p>}
                <p className={styles.description}>
                  Votre tableau de bord est prêt. Les fonctionnalités seront ajoutées progressivement.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
